export interface IDeleteOutputDto {
    isDeleted?: boolean;
    deletedAt?: string;
}
